module.exports = __webpack_public_path__ + "static/media/forBoys.fe8b35e7.png";